import {type Issue, type IssueLine, type TimestampKeyTuple} from './types';
import {getXValueForTimestamp, parseCacheKey} from './utils';

const EMPTY_KEY_BY_TIMESTAMP: TimestampKeyTuple[] = [];

export function resolveKeyByTimestamp(
  timestampsByCacheKey: Record<string, TimestampKeyTuple[]>,
  cacheKey: string
): TimestampKeyTuple[] {
  const keyByTimestamp = timestampsByCacheKey[cacheKey];
  if (keyByTimestamp?.length) {
    return keyByTimestamp;
  }
  const {xAxis} = parseCacheKey(cacheKey);
  return timestampsByCacheKey[`${xAxis}-null-null`] ?? EMPTY_KEY_BY_TIMESTAMP;
}

/**
 * This function takes a list of issues and a list of timestamp-key tuples (representing points on a timeline). For each issue, it finds the closest matching timestamp in the timeline and creates an IssueLine object with the calculated x-position and other metadata. Issues that don't match the timeline range are skipped. The result is an array of IssueLine objects, ready for rendering on a time-based chart.
 */
export function convertIssuesToTimestampKeyTuples(
  issues: Issue[],
  keyByTimestamp: TimestampKeyTuple[]
) {
  const convertedIssuesList: IssueLine[] = [];
  let searchStartIndex = 0; // Track index instead of slicing arrays

  issues.forEach(issue => {
    // Use optimized search that starts from our last position
    const result = getXValueForTimestamp(
      keyByTimestamp,
      issue.timestamp,
      searchStartIndex
    );
    if (result === undefined) {
      // this represents an issue outside the range of this zoom
      return;
    }
    searchStartIndex = result.bottomIndex; // Update search start position
    convertedIssuesList.push({
      left: 0,
      id: issue.id,
      status: result.status,
      timestamp: issue.timestamp,
      xValue: result.value,
    });
  });
  return convertedIssuesList;
}
